module.exports = __webpack_public_path__ + "static/media/Angst.19b9b00d.mp3";